module.exports = __webpack_public_path__ + "static/scott-7ffed020c8c94dc5b2931cbfa38b39e6.jpg";